export function IllegalMapOperationError(message) {
  this.name = 'IllegalMapOperationError';
  this.message = message;
  this.stack = (new Error()).stack;
}

IllegalMapOperationError.prototype = new Error();



// WEBPACK FOOTER //
// ./lib/custom_errors.js